import { useState } from "react";
import { toast } from "sonner";
import { Loader2, ShieldCheck } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ChangePassword() {
  const { user, setUser, logout } = useAuth();
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) return toast.error("Passwords do not match");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: next });
      toast.success("Password updated");
      setUser({ ...user, must_change_password: false });
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0F172A] text-white flex flex-col items-center justify-center px-4 font-sans">
      <div className="w-full max-w-sm">
        <div className="flex justify-center mb-8"><Logo light /></div>
        <div className="rounded-2xl border border-slate-700 bg-[#1E293B] p-6">
          <div className="flex items-center gap-2 text-emerald-400"><ShieldCheck className="w-5 h-5" /><h1 className="text-xl font-bold tracking-tight text-white">Set a new password</h1></div>
          <p className="text-sm text-slate-400 mt-1">For your security, please change the temporary password before continuing.</p>
          <form onSubmit={submit} className="mt-5 space-y-4">
            <div><Label className="text-xs text-slate-400">Current password</Label><Input data-testid="cp-current-input" type="password" value={cur} onChange={(e) => setCur(e.target.value)} required className="mt-1 bg-[#0F172A] border-slate-700 text-white" /></div>
            <div><Label className="text-xs text-slate-400">New password</Label><Input data-testid="cp-new-input" type="password" value={next} onChange={(e) => setNext(e.target.value)} required className="mt-1 bg-[#0F172A] border-slate-700 text-white" /></div>
            <div><Label className="text-xs text-slate-400">Confirm new password</Label><Input data-testid="cp-confirm-input" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required className="mt-1 bg-[#0F172A] border-slate-700 text-white" /></div>
            <p className="text-xs text-slate-500">Min 8 characters with uppercase, lowercase, number and symbol.</p>
            <Button data-testid="cp-submit-button" type="submit" disabled={busy} className="w-full h-11 bg-emerald-600 hover:bg-emerald-500 text-white font-semibold rounded-lg">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Update password"}</Button>
          </form>
          <button onClick={logout} className="mt-4 w-full text-center text-xs text-slate-500 hover:text-slate-300">Log out</button>
        </div>
      </div>
    </div>
  );
}
